import { gql } from "@apollo/client";

const GET_INVOICE_OVERVIEW_DETAILS = gql`
  query getInvoiceOverviewDetails(
    $clientIdentifier: String!
    $invoiceId: String!
  ) {
    invoice(clientIdentifier: $clientIdentifier, invoiceId: $invoiceId) {
      id
      invoiceFileId
      invoiceNumber
      template {
        id
        name
      }
      state {
        assessmentStatus
        processStatus
        registrationStatus
        validationStatus
      }
      createdAt
      registeredByUser {
        id
        firstName
        lastName
      }
      validatedByUser {
        id
        firstName
        lastName
      }
      assessedByUser {
        id
        firstName
        lastName
      }
      dueDate
      invoiceDate
      invoiceNumber
      totalVatAmount
      currencyCode
      shippingCost
      rounding
      invoiceIssuer {
        issuerReference
        client {
          id
          name
        }
      }
      invoiceRecipient {
        name
        recipientEmail
        address1
        address2
        city
        countryCode
        customerCode
        zipCode
        client {
          id
          name
        }
        clientIdentifier
        distributionType
        ediAddress
      }
      modifiedAt
      totalAmountWithVat
      tags {
        tag
      }
      rows {
        articleNumber
        description
        quantity
        unitPrice
        unitType
        discountPercentage
        discountAmount
        vatPercentage
        totalVatAmount
        invoiceRowId
      }
      latestValidation {
        isValid
        invoiceId
        invoiceDataValidationId
        createdAt
        fieldValidations {
          createdAt
          fieldType
          invoiceFieldDataValidationId
          isValid
          value
        }
        rowValidations {
          createdAt
          invoiceRowDataValidationId
          invoiceRowId
          isValid
          rowFieldValidations {
            createdAt
            fieldType
            invoiceFieldDataValidationId
            isValid
            value
          }
        }
        ruleValidations {
          invoiceValidationDeterminationId
          message
          result
          rules {
            invoiceValidationDeterminationRuleId
            message
            passed
            ruleName
            ruleType
            score
            warning
          }
        }
      }
      uploadDocument {
        id
        comments(skip: 0, take: 5) {
          totalCount
          items {
            content
            createdAt
            createdByUser {
              id
              firstName
              lastName
            }
            id
          }
        }
        invoiceRecipientEmails
        invoiceRecipientGln
        userMessage
        serviceType
        invoiceUploadUnit {
          id
          emailDetails {
            isHtml
            messageId
            previewBody
            rawBody
            receivedDate
            recipients
            sentFromEmail
            subject
          }
          isBlacklisted
          uploadType
          createdByUser {
            id
            firstName
            lastName
          }
          statusHistory {
            status
            setAt
          }
        }
      }
      serviceType
      latestAssessment {
        createdAt
        passed
        decision
        manualReviewRequired
        rules {
          invoiceAssessmentRuleId
          message
          passed
          ruleName
          ruleType
          score
          warning
        }
        ruleOverrides {
          createdAt
          invoiceAssessmentRuleId
          overriddenByUser {
            id
            firstName
            lastName
          }
          reason
        }
      }
      rejectionComments {
        items {
          content
          createdAt
          createdByUser {
            id
            firstName
            lastName
          }
          id
        }
      }
      isCreditInvoice
      ledgerInvoice {
        distributedAt
        distributionMethod
        externalDistributionMethod
        factoringSystemInvoiceId
        internalInvoiceId
        overdueStatus
        overdueStatusChangedAt
        paymentStatusIssuer
        paymentStatusIssuerChangedAt
        paymentStatusRecipient
        paymentStatusRecipientChangedAt
        recourseStatus
        recourseStatusChangedAt
        registrationStatus
        state
        stateChangedAt
      }
    }
  }
`;

export default GET_INVOICE_OVERVIEW_DETAILS;
